require('../modules/es6.symbol');
require('../modules/es6.object.to-string');
module.exports = require('../modules/_core').Symbol;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/es6/symbol.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/es6/symbol.js
// module chunks = 0